import React, { useMemo, useState } from 'react'

import {
  getUnitExtension,
  postUnitExtension,
  deleteUnitExtension,
} from 'api/pgads.js'
import { Input, Button, Select } from 'antd'

import CommonScreen from './CommonScreen'
import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
  utilityHeader,
  YNBooleanTypes,
} from 'core/HeaderColTypeProps'
import { strCol } from '@integec/grid-tools/lib/cols'
import {
  getApiTargetInfo,
  getUnitNameMap,
  getUtilityNameMap,
  UtilityUnitSelection,
} from 'core'
import { connect } from 'react-redux'
import { toSelectionColProps } from '@integec/grid-tools'

const title = 'Unit Extension'

const UnitExtension = ({ unitNameMap, utilityNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ textAlign: 'right', minWidth: '150px' }} colSpan={1}>
              Utility / Unit :
            </td>
            <td colSpan={3}>
              <UtilityUnitSelection
                utility={insertData.utility}
                unit={insertData.unit}
                onUnitChange={value => {
                  setInsertData({
                    ...insertData,
                    utility: value[0],
                    unit: value[1].substr(3),
                    unitId: value[1],
                  })
                }}
              />
            </td>
            <td style={{ textAlign: 'right' }}>Gen Details : </td>
            <td>
              <Select
                style={{ width: '100%' }}
                value={insertData.genDetail}
                onChange={genDetail =>
                  setInsertData({
                    ...insertData,
                    genDetail,
                  })
                }
              >
                <Select.Option value="HOURLY">HOURLY</Select.Option>
                <Select.Option value="DAILY">DAILY</Select.Option>
                <Select.Option value="MONTHLY">MONTHLY</Select.Option>
              </Select>
            </td>
            <td style={{ textAlign: 'right' }}>Track Station Service : </td>
            <td>
              <Select
                style={{ width: '100%' }}
                value={insertData.trackStationService}
                onChange={trackStationService =>
                  setInsertData({
                    ...insertData,
                    trackStationService,
                  })
                }
              >
                <Select.Option value="Y">Y</Select.Option>
                <Select.Option value="N">N</Select.Option>
              </Select>
            </td>

            <td style={{ textAlign: 'right' }}>Hydro Mode : </td>
            <td>
              <Input
                value={insertData.hydroMode}
                onChange={e =>
                  setInsertData({ ...insertData, hydroMode: e.target.value })
                }
              />
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Id 1 : </td>
            <td>
              <Input
                value={insertData.id1}
                onChange={e =>
                  setInsertData({ ...insertData, id1: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 2 : </td>
            <td>
              <Input
                value={insertData.id2}
                onChange={e =>
                  setInsertData({ ...insertData, id2: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 3 : </td>
            <td>
              <Input
                value={insertData.id3}
                onChange={e =>
                  setInsertData({ ...insertData, id3: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 4 : </td>
            <td>
              <Input
                value={insertData.id4}
                onChange={e =>
                  setInsertData({ ...insertData, id4: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 5 : </td>
            <td>
              <Input
                value={insertData.id5}
                onChange={e =>
                  setInsertData({ ...insertData, id5: e.target.value })
                }
              />
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Id 6 : </td>
            <td>
              <Input
                value={insertData.id6}
                onChange={e =>
                  setInsertData({ ...insertData, id6: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 7 : </td>
            <td>
              <Input
                value={insertData.id7}
                onChange={e =>
                  setInsertData({ ...insertData, id7: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 8 : </td>
            <td>
              <Input
                value={insertData.id8}
                onChange={e =>
                  setInsertData({ ...insertData, id8: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 9 : </td>
            <td>
              <Input
                value={insertData.id9}
                onChange={e =>
                  setInsertData({ ...insertData, id9: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Id 10 : </td>
            <td>
              <Input
                value={insertData.id10}
                onChange={e =>
                  setInsertData({ ...insertData, id10: e.target.value })
                }
              />
            </td>
          </tr>
          <tr>
            <td colSpan={6} />
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = useMemo(
    _ =>
      UnitnamesExtensionHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={postUnitExtension}
      retrieveTask={getUnitExtension}
      deleteTask={deleteUnitExtension}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={headerWithFormatter}
      insertComp={insertEvent && insertComp}
      insertCompHeight={200}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(UnitExtension)

const UnitnamesExtensionHeaders = [
  // strCol({ident:'utility',display:'Utility',isKey:true}),
  // strCol({ident:'unit',display:'Unit',isKey:true}),
  utilityHeader,
  unitIdHeader,
  strCol({ ident: 'genDetail', display: 'GenDetail', isFiltered: true }),
  strCol({
    ident: 'trackStationService',
    display: 'Track Station Service',
    isFiltered: true,
    width: 150,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  strCol({ ident: 'hydroMode', display: 'HydroMode', isFiltered: true }),
  strCol({ ident: 'id1', display: 'Id1', isFiltered: true }),
  strCol({ ident: 'id2', display: 'Id2', isFiltered: true }),
  strCol({ ident: 'id3', display: 'Id3', isFiltered: true }),
  strCol({ ident: 'id4', display: 'Id4', isFiltered: true }),
  strCol({ ident: 'id5', display: 'Id5', isFiltered: true }),
  strCol({ ident: 'id6', display: 'Id6', isFiltered: true }),
  strCol({ ident: 'id7', display: 'Id7', isFiltered: true }),
  strCol({ ident: 'id8', display: 'Id8', isFiltered: true }),
  strCol({ ident: 'id9', display: 'Id9', isFiltered: true }),
  strCol({ ident: 'id10', display: 'Id10', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]
